import { useTranslation } from 'react-i18next';

/**
 * P-05 (D-56) — the progress bar of a milestone / sub-milestone / task row
 * (read-only). P-10e (D-82): a task's percent is its saved bar (never below
 * its status), and milestones / projects average those (projectMetrics). The
 * bar is moved only in the ⏸ / ✓ windows (`TaskProgressField`).
 */
export default function MilestoneProgressBar({ value, label, className = '', size = 'sm' }: {
  value: number;
  /** What the bar is the progress of (its accessible name). */
  label?: string;
  className?: string;
  size?: 'sm' | 'md';
}) {
  const { t } = useTranslation();
  const pct = Math.max(0, Math.min(100, Math.round(value)));
  const h = size === 'md' ? 'h-2' : 'h-1.5';
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <span
        className={`${h} min-w-12 flex-1 rounded-full bg-surface-100`}
        role="progressbar"
        aria-valuenow={pct}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={label ? t('milestoneList.progressOf', { name: label }) : t('projectPage.progress')}
      >
        <span className={`block ${h} rounded-full bg-primary-600 transition-[width] duration-200`} style={{ width: `${pct}%` }} />
      </span>
      <span className="text-xs font-semibold tabular-nums text-text">{pct}%</span>
    </span>
  );
}
